import { TFieldConfig } from "../types/common";

export const apiIntegrationFields: TFieldConfig[] = [
  {
    field_name: "reference",
    type: "text",
    label: "Reference",
    props: { required: true },
  },
  {
    field_name: "amount",
    type: "number",
    label: "Amount",
    props: { required: true },
  },
  {
    field_name: "customer_name",
    type: "text",
    label: "Customer Name",
    props: { required: false },
  },
  {
    field_name: "logo_url",
    type: "text",
    label: "Logo Url",
    props: { required: true },
  },
  // {
  //   field_name: "public_key",
  //   type: "text",
  //   label: "Public Key",
  //   props: { required: true, disabled: true },
  // },
];

export const requestPublicKeyFields: TFieldConfig[] = [
  {
    field_name: "user",
    type: "text",
    label: "User",
    props: { required: true },
  },
];
